/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { setDialogs } from '../../actions';
import './index.scss';
import defaultIntegral from './defaultIntegral';
import { getSchemeHeader } from '../../lib/util/utils';
import { CardTitle, SignInCoinDialog, WelfareGuideDialog } from '../../components';
import { loginAction, doPreProcess, getWelfareCenterParams, getMyIntegralAction, getTaskDataAction } from '../../rootStore';
import store from '../../store';
import { detector } from '../../lib/util/Detect.js';
import { $http, isHighVersion } from '../../lib/kbApp/kbJsBridgePromise';
import { query } from '../../lib/util/common';
import { showTip } from '../../lib/util/domUtil.js';
import sendBoss from '../../lib/base/sendBoss';
import { goNovelTab } from '@tencent/novel-open-addr';
import { init } from '@tencent/novel-open-base';
import { has } from 'lodash';
import { TASK_EVOLVE_TYPE, BLACK_USER_DIALOG, NOVEL_WELFARE_PAGE_ADDR_FOR_TASK } from '../../const/index';
import { openMotivationVideo } from '../../lib/util/nfa';
import Log from '../../lib/util/log';

const logPrefix = 'kd_welfare_h5.CoinTask';

class CoinTask extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      taskData: [],
      smallPrice: 0,
      taskContrlClassName: 'hidden',
      sysPushState: 0,
      isTargetVersion: false,
    };
    this.searchWords = [];
    // 确认AMSSDK加载完毕，防止多次调用
    this.isAMSSDKLoading = false;
    this.Log = this.props.Log;
  }

  async componentDidMount() {
    this.props.dailyTask.map((task) => {   // 在这里上报曝光，防止重复上报
      this.Log && this.Log.sendExposure({
        element_type: 'task',
        task_id: task.taskId,
        business_id: task.businessId,
      });
    });
    // 请求最小的奖品价格
    // const smallPrice = await getSmallPrice();
    // console.log(`smallPrice ${smallPrice}`);
    // this.setState({ smallPrice });
    init();

    const targetVersion = detector.os.ios ? '11.4.1' : '11.4.1.1062';
    try {
      const isTargetVersion =  await isHighVersion(targetVersion);
      this.setState({ isTargetVersion });
    } catch (error) {
      console.error(error);
    }
  }

	// 点击任务
	conTaskClick = (task, taskComplated) => {
	  const { taskEvolve } = task;
	  if ([
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_GUID,
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_QBID,
	  ].includes(taskEvolve)) {
	    if (has(window, 'browser.app.showAlertDialog')) {
	      window.browser.app.showAlertDialog(() => {}, BLACK_USER_DIALOG);
	    }
	    return;
	  }
	  // keyType===1 需要登录才能做的任务 iStatus === 3 表示需要领取奖励的任务 都需要登录
	  if (!this.props.isLogin && (task.keyType === 1 || task.iStatus === 3)) {
	    loginAction();
	  } else {
	    // 快报任务和qb任务分开处理
	    if (detector.app.kuaibao) {
	      this.dealKbTask(task, taskComplated);
	    } else if (detector.app.qb) {
	      this.dealQbTask(task);
	    }
	  }
	}

	// 处理qb任务
	dealQbTask = (task) => {
	  const _url = task.url;

	  if (task.completed >= 0 && task.completed < task.totalStep) {
	    if (!task.taskAccept) { // 未领取任务需要手动领取
	      this.acceptTask(task.taskId).then((res) => {
	        if (res.code !== 0) {
	          showTip('任务领取失败', 3000);
	          return;
	        }
	      });
	    }

	    if (task.businessId === 10001 && Number(query('from_where')) === 10888) {
	      if (!this.props.isLogin) {
	        loginAction();
	        return;
	      }

	      const param = Object.assign(getWelfareCenterParams(), {
	        refer: query('refer') || '',
	      });

	      sendBoss('element_exposure', {
	        page_id: 'welfareIndex',
	        element_type: 'login_mission',
	        element_name: 'login_popup_success',
	      });


	      this.props.dispatch(setDialogs([
          <WelfareGuideDialog key={ 1 } confirmCb={ async () => {
            sendBoss('element_click', {
              page_id: 'welfareIndex',
              element_type: 'login_mission',
              element_name: 'login_popup_success',
            });

            const reportRet = await $http.post('/ugwelfare/api/tasks/reportTaskEnvolve', {
              data: Object.assign({}, param, {
                taskType: task.taskType,
                omgid: param.guid,
                openid: param.qbid,
                businessId: task.businessId,
                reportBusinessId: task.businessId,
                taskId: task.taskId,
                step: 1,
                type: 0,
                source: query('task_source') || 'welfarecenter', // 任务领取来源
              }),
            });

            console.log('reportRet', reportRet);

            $http.post('/newtickets/api/sendTaskWelfare', {
              // 上报任务进度
              data: Object.assign(getWelfareCenterParams(), {
                taskId: task.taskId,
                businessId: task.businessId,
              }),
            }).then((res) => {
              if (res.code === 0) {
                let welfareValue = 0;
                let welfareType = 3;
                let welfare = {};

                if (res.data.integral) { // 金币
                  welfareType = 3;
                  welfareValue = res.data.integral;
                } else if (res.data.coupons && res.data.coupons.length) { // 广告礼券
                  welfareType = 1;
                  welfare = {
                    coupons: res.data.coupons,
                  };
                } else if (res.data.amount) { // 红包
                  welfareType = 0;
                  welfareValue = res.data.amount;
                }

                const { dialogs } = store.getState();
                const len = dialogs.length;

                sendBoss('element_exposure', {
                  page_id: 'welfareIndex',
                  element_type: 'login_mission',
                  element_name: 'get_popup_success',
                });

                this.props.dispatch(setDialogs(<SignInCoinDialog key={ len } from="task" welfare={ welfare } value={ welfareValue } welfareType={ welfareType }
                  confirmCb={ () => {
                    sendBoss('element_click', {
                      page_id: 'welfareIndex',
                      element_type: 'login_mission',
                      element_name: 'get_popup_success',
                    });
                  }}
                ></SignInCoinDialog>));
                //   getMyIntegralAction();
                getTaskDataAction(false, 'sendTask');
              }
            })
              .catch(e => console.log(e));
          }}></WelfareGuideDialog>,
	      ]));
	      return;
	    } if (task.businessId === 1600) {
	      // 第三方广告任务，要获取token
	      // const token = await accountService.getTokenByAppkey(this.userInfo, 'qb_tuia_2019');
	      // window.location.href = task.url + `&_ext_token=${token}&device_id=${this.userInfo.guid}`;
	    } else if (task.businessId === 900) {
	      // const res = await taskService.getSoftWareName(this.userInfo);

	      // window.location.href = task.url + res.data.name;
	    } else if (task.businessId === 1002) {
	      window.aegisIns && window.aegisIns.info(`qb ad fuc: ${window.NFA}`);

	      // 点击锁
	      if (this.isAMSSDKLoading) {
	        return;
	      }

	      this.isAMSSDKLoading = true;

	      const param = Object.assign(getWelfareCenterParams(), {
	        refer: query('refer') || '',
	      });

	      const openVideoParams = {
	        appId: 35,
	        posId: 100310,
	        businessId: 1002,
	      };

	      openMotivationVideo(
					param?.guid,
					openVideoParams,
					(res) => {
					  // 事件回调
					  window.aegisIns && window.aegisIns.info(`qb ad res: ${res}`);

					  // 发放奖励，刷新资产
					  getMyIntegralAction();
					  getTaskDataAction(false);

					  this.isAMSSDKLoading = false;
					},
					{
					  onLoadAdFail: (res) => {
					    Log.getInstance().logErr(`${logPrefix} watchAdsVideo loadAdFailed. Params: ${JSON.stringify(openVideoParams,)}. Res: ${JSON.stringify(res)}. WelfareCenterParams: ${JSON.stringify(param)}.`);

					    showTip('线路拥挤，请稍后再试', 3000);
					    this.isAMSSDKLoading = false;
					  },
					  onError: (res) => {
					    Log.getInstance().logErr(`${logPrefix} watchAdsVideo loadAdError. Params: ${JSON.stringify(openVideoParams,)}. Res: ${JSON.stringify(res)}. WelfareCenterParams: ${JSON.stringify(param)}.`);

					    showTip('活动火爆，请稍后再试', 3000);
					    this.isAMSSDKLoading = false;
					  },
					  onUnknown: (res) => {
					    Log.getInstance().logErr(`${logPrefix} watchAdsVideo loadAd onUnknown. Params: ${JSON.stringify(openVideoParams,)}. Res: ${JSON.stringify(res)}. WelfareCenterParams: ${JSON.stringify(param)}.`,);
					    this.isAMSSDKLoading = false;
					  },
					},
	      );
	      return;
	    } else if (task.businessId === 301) {
	      // goNovelTab(0, { ch: '005160' });
	      // 跳转到小说福利
	      window.location.href = NOVEL_WELFARE_PAGE_ADDR_FOR_TASK;
	      return;
	    } else if (task.businessId === 1001 && detector.os.android) {
	      // 1001 是打开push开关场景
	      if (has(window, 'browser.app.asyncSystemPushOn') &&  has(window, 'browser.app.turnToSysPush')) {
	        window.browser.app.asyncSystemPushOn((res) => {
	          // sysPushState = 1 打开状态 =0 关闭状态
	          console.log(res.sysPushState, 'sysPushState');
	          if (!res.sysPushState) {
	            return window.browser.app.turnToSysPush();
	          }
	          // 如果已经打开push 并且调用接口后接口会上报任务进度 这里即认为任务已经完成了
	          return showTip('您已完成任务，请刷新页面领取奖励', 5000, { style: 'width: 2rem;' });
	        }, { scene: 'welfare' });
	      }
	      return;
	    } else if (task.businessId === 1204) {
	      showTip('正在加载游戏，请稍等', 1000);

	    $http.get('/ugwelfare/api/minigame/getWelfareTaskGame', {
	      params: getWelfareCenterParams(),
	    }).then((res) => {
	        // 上报成功
	        sendBoss('getWelfareTaskGame', {
	          element_type: res.code,
	          extra_info: {
	            games: `${JSON.stringify(res.data.games)}`,
	          },
	        });

	        if (res.code === 0 && res.data.games && res.data.games.length) {
	          const [gameInfo] = res.data.games;

	          const url = gameInfo.qb_url;

	          if (window.browser && window.browser.app && window.browser.app.openUrl) {
	            window.browser.app.openUrl(null, null, { url });
	          } else {
	            return window.location.href = url;
	          }
	        } else {
	          showTip('获取游戏信息失败，请稍后再试');
	        }
	      })
	        .catch((err) => {
	          console.log('getWelfareTaskGame err', err);
	        showTip('获取游戏信息失败，请稍后再试');
	      });
	      return;
	    } else if (task.hasStepAward) {
	      this.sendTaskRedPackV2(task.taskId, task.businessId, task.taskBelong);
	      sendBoss('element_click', {
	        element_type: 'task',
	        element_name: 'receive_welfare',
	        task_id: task.taskId,
	        business_id: task.businessId,
	      });
	      return ;
	  }

	    window.location.href = _url;
	  } else if (task.completed >= task.totalStep) {
	    // 301小说阅读任务直接return
	    if (task.businessId === 301) return;
	    const stepWelfare = Object.values(task.stepWelfare);
	    let welfare = stepWelfare[stepWelfare.length - 1];
	    // 连续任务，通过continueTaskDays拿到福利
	    if (task.isContinueTask) {
	      welfare = stepWelfare[task.continueTaskDays ? task.continueTaskDays - 1 : 0];
	    }

	    if (welfare && !welfare.geted) {
	      this.sendTaskRedPackV2(task.taskId, task.businessId, task.taskBelong);
	    }
	    sendBoss('element_click', {
	      element_type: 'task',
	      element_name: 'receive_welfare',
	      task_id: task.taskId,
	      business_id: task.businessId,
	    });
	  }
	}

	// 领取奖励
	sendTaskRedPackV2 = (taskId, businessId, taskBelong) => {
	  $http.post('/newtickets/api/sendTaskWelfare', {
	    data: Object.assign(getWelfareCenterParams(), {
	      taskId,
	      businessId,
	    }),
	  }).then((res) => {
	    sendBoss('sendTaskRedPackResponce', {
	      extra_info: { time: new Date().getTime(), res },
	    });
	    // const myIntegral = this.props.myIntegral || {};
	    if (res.code === 0) {
	      let welfareValue = 0;
	      let welfareType = 3;
	      let welfare = {};

	      if (res.data.integral) { // 金币
	        welfareType = 3;
	        welfareValue = res.data.integral;
	      } else if (res.data.coupons && res.data.coupons.length) { // 广告礼券
	        welfareType = 1;
	        welfare = {
	          coupons: res.data.coupons,
	        };
	      } else if (res.data.amount) { // 红包
	        welfareType = 0;
	        welfareValue = res.data.amount;
	      }

	      const len = this.props.dialogs.length;
	      this.props.dispatch(setDialogs(this.props.dialogs.concat([
					<SignInCoinDialog key={len} from="task" welfare={welfare} value={welfareValue} welfareType={welfareType}></SignInCoinDialog>,
	      ])));

	      //   getMyIntegralAction();
	      getTaskDataAction(false, 'sendTask');
	    }
	  })
	    .catch((res) => {
	      if (res && res.code) {
	        switch (Number(res.code)) {
	          case -1600:
	            showTip('领取过于频繁', 3000);
	            break;
	          case 4013:
	            showTip('很抱歉，设备已经绑定别的账号，需要登录绑定账号才可以继续参加活动', 3000);
	            break;
	          case 402:
	            showTip('账号状态异常请重新登录', 3000);
	            break;
	          case 4016:
	            showTip('该账号今日已领取该奖励，请勿重复操作', 5000, { style: 'width: 2rem;' });
	            break;
	          default:
	            showTip(`领取红包失败(${res.code})`, 3000);
	            break;
	        }
	      } else {
	        showTip('领取红包失败', 3000);
	      }
	    });
	}

	// 处理快报任务
	dealKbTask = (task, taskComplated) => {
	  if (taskComplated) {  // 任务已完成，点击无反应
	    return;
	  }
	  // 如果是广告任务
	  if (task.businessId === 3100) {
	    // 展示广告，点击广告时展示
	    window.QBExcitedVideoAdApi && window.QBExcitedVideoAdApi.showAD();
	  } else {
	    const _url = getSchemeHeader() + task.sJumpUrl;
	    window.location.href = _url;
	  }
	}

	// 领取任务
	acceptTask = taskId => $http.put('/newtickets/api/tasks/accept', {
	  data: Object.assign(getWelfareCenterParams(), {
	    taskId,
	    source: query('task_source') || 'welfarecenter', // 任务领取来源
	  }),
	})

	// 获取搜索词
	getSearchWords = (url) => {
	  $http.post('/newtickets/api/getSearchWords', {
	    data: Object.assign(getWelfareCenterParams(), {}),
	  }).then((res) => {
	    if (res.code === 0) {
	      const searchWords = res.data || [];

	      if (Array.isArray(searchWords)) {
	        const searchWord = searchWords[0] || '';
	        console.log('getSearchWords success');
	        url = url + searchWord;
	        window.location.href = url;
	      } else {
	        console.log('getSearchWords fail');
	        showTip('获取搜索词失败', 2000);
	      }
	    } else {
	      showTip('获取搜索词失败', 2000);
	    }
	  })
	    .catch(() => {
	      showTip('获取搜索词失败', 2000);
	    });
	}

	// 任务列表
	taskDataRender = (task, index) => {
	  let { stepWelfare } = task;
	  if (!stepWelfare.length) {
	    stepWelfare = Object.values(task.stepWelfare);
	  }

	  // 金币取第一步的值显示，随任务配置生效
	  let integralValue = stepWelfare && stepWelfare[0] && stepWelfare[0].integral && stepWelfare[0].integral.integralValue ? stepWelfare[0].integral.integralValue : '';
	  // 默认金币配置
	  integralValue = integralValue || defaultIntegral[task.businessId];

	  // 已完成任务
	  let taskComplated = false;
	  let taskStatus = 2; // 2：未完成  3：已完成未领取奖励   4：已完成已领取奖励
	  if ((task.completed >= task.totalStep && task.totalStep > 0) || task.iStatus === 4) {
	    taskComplated = true;

	    let welfare = stepWelfare[stepWelfare.length - 1];
	    // 连续任务，通过continueTaskDays拿到福利
	    if (task.isContinueTask) {
	      welfare = stepWelfare[task.continueTaskDays ? task.continueTaskDays - 1 : 0];
	    }

	    taskStatus = 4;
	    task.actionText = '已完成';

	    if (detector.app.qb && welfare && !welfare.geted && task.businessId !== 301) {  // 快报直接到账，qb需要主动领取奖励
	      taskStatus = 3;
	      task.actionText = '领奖励';
	    }
	  } else if (task.completed > 0 && task.totalStep > 0) {
	    taskStatus = 2;
	    task.actionText = '继续';
	    for (const step of stepWelfare) {
	      const { completedTime, geted } = step;
	      // 有未领取的步长奖励
	      if (completedTime > 0 && !geted) {
	        taskStatus = 3;
	        task.actionText = '领奖励';
	        task.hasStepAward = true;
	        break;
	      }
	    }
	  }

	  if (task.businessId === 10001 && Number(query('from_where')) === 10888 && task.completed < task.totalStep && this.props.isLogin) {
	      task.actionText = '领奖励';
	  }

	  let totleIntegral = 0;
	  let getIntegral = 0;
	  let progressWidth = 0;
	  let showBubble = true;
	  let showEndBubble = true;
	  const degree = [];
	  let firstDregree = 0;
	  let firstDregreeWith = 0;
	  let firstDregreeIntegral = 0;
	  if (task.taskType === 1) { // 时长任务
	    let lastDegree = 0;
	    for (const i in task.stepWelfare) {
	      if (task.stepWelfare[i].integral) {
	        const { integral } = task.stepWelfare[i];
	        totleIntegral += integral.integralValue || 0;

	        if (task.completed >= i) {
	          getIntegral += integral.integralValue || 0;
	        }

	        if (task.stepWelfare[i].stepDesc) {  // 刻度
	          degree.push({
	            degreeIntegral: totleIntegral,
	            stepDesc: task.stepWelfare[i].stepDesc,
	            degreeTime: i,
	          });
	          if (i < task.totalStep) { // 寻找展示的最大刻度
	            lastDegree = i;
	          }

	          // 找出第一个刻度
	          if (firstDregree === 0) {
	            firstDregree = +i;
	            firstDregreeIntegral = totleIntegral;
	          }
	        }
	      }
	    }

	    if (task.completed <= 0) { // 已获得金币，才会展示进度气泡
	      showBubble = false;
	    }

	    integralValue = totleIntegral;  // 文章视频取总值
	    progressWidth = (100 * task.completed / task.totalStep).toFixed(2);
	    firstDregreeWith = (100 * firstDregree / task.totalStep).toFixed(2);

	    // 有刻度的话完成任务步数在最大刻度之前，没刻度的话完成任务小于一半，才会展示灰色完成气泡
	    if ((lastDegree > 0 && task.completed > lastDegree) || (lastDegree <= 0 && progressWidth > 70)) {
	      showEndBubble = false;
	    }
	  }
	  // 处理下任务描述字符截断
	  if (task.taskType === 0 && task.totalStep > 0) {
	    const progressDesc = `（${task.completed}/${task.totalStep}）`;
	    task.formatDesc = task.description + progressDesc;

	    if (task.formatDesc.length > 20) {
	      const _needLen = (20 - progressDesc.length);
	      task.formatDesc = task.description.substr(0, _needLen) + progressDesc;
	    }
	  } else {
	    task.formatDesc = task.description.substr(0, 20);
	  }

	  const stepStyle = () => (
			<div className={`taskItem status${taskStatus} ${task.taskType === 1 ? '' : 'padding-20'}`} key={index}>
				<div className="task-item__box">
          {/* 这里也要特殊处理下小说阅读任务 标题和 */}
          <div className="task-info">
            <div className="coinTaskName">
              {task.sTitle}
              {/* 301场景下不展示获得金币数，因为不准确 */}
              {task.businessId === !301 && !!integralValue
                && <React.Fragment>
                  <span className="count">+{integralValue}</span>
                  <span className="icon"></span>
                </React.Fragment>
              }
            </div>
            <div className="taskTip">
              {task.formatDesc}
            </div>
          </div>
          <div
            className="taskBtn"
            log-click-eltype="task"
            log-click-elname="task_click"
            log-click-taskid={task.taskId}
            log-click-businessId={task.businessId}
            onClick={() => {
              doPreProcess(this.conTaskClick)(task, taskComplated);
            }}
          >
            {task.actionText}
          </div>
				</div>
        {/* 这里加一个场景的过滤，小说阅读任务、小程序授权任务、新游下载任务不需要展示进度条和（x/y） */}
				{/* 任务不需要展示进度条和（x/y）条件～需为配为时长任务，代码层面单独过滤 */}
				{task.taskType === 1 && ![301, 1201, 900, 1204].includes(task.businessId)
					&& <div className="progressWrap">
						<div className="timeLine">
							{detector.app.kuaibao && !!showBubble
								&& <div className="bubbleBox" style={{ left: `${progressWidth}%` }}>
									<div className="bubble">{getIntegral}金币</div>
									<div className="triggle"></div>
								</div>
							}
							{detector.app.kuaibao && (progressWidth <= 0 && firstDregree !== 0)
								&& <div className="bubbleBox gray" style={{ left: `${firstDregreeWith}%` }}>
									<div className="bubble">{firstDregreeIntegral}金币</div>
									<div className="triggle"></div>
								</div>
							}
							{!!showEndBubble
								&& <div className="bubbleBox bubbleEnd">
									<div className="bubble">{totleIntegral}金币</div>
									<div className="triggle"></div>
								</div>
							}
							<div className="progress" style={{ width: `${progressWidth}%` }}></div>
							{(progressWidth > 0)
								&& <div className="progressIcon" style={{ left: `${progressWidth}%` }}></div>
							}
							{degree.map((item, index) => {
							  const pos = (100 * item.degreeTime / task.totalStep).toFixed(2);

							  return (
									<div className="degree" key={index} style={{ left: `${pos}%` }}>
										<div className="point"></div>
										<div className="desc">{item.stepDesc}</div>
									</div>
							  );
							})}
						</div>
					</div>
				}
			</div>
	  );

	  // 这个样式是之前福利中心按步长梯度展示小说阅读任务的，后续需要可以重新使用

	  // const multipleStepStyle = () => {
	  //   const { stepWelfare } = task;
	  //   const stepList = Object.entries(stepWelfare).map(([key]) => parseInt(key, 10));

	  //   return Object.entries(stepWelfare)
	  //   .map(([key, stepInfo], index) => {
	  //       const taskStatus = stepInfo.geted ? 4 : 2;
	  //       const isGoing = index - 1 >= 0
	  //         ? task.completed > stepList[index - 1] && task.completed < stepList[index]
	  //         : task.completed < stepList[index] && task.iStatus === 2;
	  //       return (
	  // 	<div className={`taskItem ${index > 1 ? this.state.taskContrlClassName : ''} status${taskStatus} ${task.taskType === 1 ? '' : 'padding-20'}`} key={`stepTask_${task.taskid}_${key}`}>
	  // 	<div className="task-item__box">
	  // 	  <div className="task-info">
	  // 		<div className="coinTaskName">
	  // 		  阅读{parseInt(key / 60, 10)}分钟
	  // 		  {[0, 4].includes(stepInfo.welfareInfo.welfareType) && (
	  //               	<React.Fragment>
	  // 				<span className="count">+{stepInfo.welfareInfo ? stepInfo.welfareInfo.value / 100 : 0}元</span>
	  // 				<span className="icon cash"></span>
	  // 			</React.Fragment>
	  // 		  )}
	  // 			{[3, 5].includes(stepInfo.welfareInfo.welfareType) && (
	  // 			<React.Fragment>
	  // 				<span className="count">+{stepInfo.welfareInfo ? stepInfo.welfareInfo.value : 0}</span>
	  // 				<span className="icon coin"></span>
	  // 			</React.Fragment>
	  // 			)}
	  // 		</div>
	  // 		<div className="taskTip">
	  // 		  {stepInfo.geted ? '已领取阅读任务奖励' : '完成阅读任务领取奖励'}
	  // 		</div>
	  // 	  </div>
	  // 	  {taskStatus === 4 ? (
	  // 		  <div className="taskBtn">已完成</div>
	  // 	  ) : (
	  // 		<div className="taskBtn" onClick={() => {
	  // 		  doPreProcess(this.conTaskClick)(task, taskComplated);
	  // 		}}>
	  // 			{isGoing ? '继续' : '去阅读'}
	  // 		</div>
	  // 	  )}
	  // 	</div>
	  //   </div>
	  //       );
	  //   });
	  // };

	  return (
		  <>
		  {stepStyle()}
		  </>
	  );
	}

	jumpToNovelRule() {
	  window.location.href = '/mall/#rule';
	}

	async jumpToReadNovel() {
	  goNovelTab(0); // 0=默认
	}

	jumpToExchange() {
	  window.location.href = `/mall?exchange=true&time=${new Date().valueOf()}`;
	}

	renderNovelProperty() {
	  const { readTime = 0 } = this.props.myIntegral;
	  const readTimeMinu = parseInt(readTime / 60, 10);
	  return (
			<div className="novel-property">
				<div className="novel-info">
					<div className="info-title">
						<span>可兑换奖品的阅读时长</span>
						<span className="rule-btn" onClick={this.jumpToNovelRule.bind(this)}>规则<i className="rule-btn-icon"></i></span>
					</div>
					<div className="info-exchange">
						<span className="time-asset">{readTimeMinu}</span><i>分钟</i>
	  					<span className="gray-tip">满{parseInt(this.state.smallPrice / 60, 10)}分钟可<i onClick={this.jumpToExchange.bind(this)} style={{ color: '#FF570F' }}>兑奖</i></span>
					</div>
				</div>
				{readTimeMinu > parseInt(this.state.smallPrice / 60, 10) ? (
					<div className="novel-action highlight" onClick={this.jumpToExchange.bind(this)}>兑奖品</div>
				) : (
						<div className="novel-action" onClick={this.jumpToReadNovel.bind(this)}>去阅读</div>
				)}
			</div>
	  );
	}

	viewMoreTask() {
	  this.setState({ taskContrlClassName: '' });
	}

	render() {
	  const { dailyTask = [] } = this.props;
	  const { isTargetVersion = false } = this.state;
	  // taskBelong = 1 表示新手任务
	  const newUserTask = [];
	  const dailyTaskNew = [];
	  const novelTask = [];

	  dailyTask.filter(task => (task.businessId !== 302)).forEach((task) => {
	    if (task.taskBelong === 1) { // 新手任务
	      newUserTask.push(task);
	    } else if (task.taskBelong === 0) { // 其他日常任务
		    if (task.businessId === 301) {
	        isTargetVersion && dailyTaskNew.push(task);
	      } else {
	        dailyTaskNew.push(task);
	      }
	    }
	  });

	  return (
			<React.Fragment>
				{newUserTask.length > 0
					&& (<div className="coinTask new-user-task">
						<div className="titleWrap">
							<CardTitle title="新手任务" subTitle="做任务领金币换零花钱"></CardTitle>
						</div>
						<div className="taskBoard">
							{
								newUserTask.map((task, index) => this.taskDataRender(task, index))
							}
						</div>
					</div>)
				}
				{/* 小说专属任务 */}
				{detector.app.qb
					&& novelTask.length > 0
					&& (<div className="coinTask">
						<div className="titleWrap">
							<CardTitle title="小说专属任务" subTitle="每天10分钟，阅读赚金币"></CardTitle>
						</div>
						<div className="taskBoard">
							{/* {novelReportTask.length > 0 && this.props.isLogin && this.renderNovelProperty()} */}
							{/* {novelTask.length > 0 && novelReportTask.length > 0 && this.props.isLogin && (<div className="devide-line"></div>)} */}
							{
								novelTask.map((task, index) => this.taskDataRender(task, index))
							}
							{this.state.taskContrlClassName === 'hidden' ? (
								<div className="more-task-btn" onClick={this.viewMoreTask.bind(this)}>
									更多小说任务
									<span className="unfold-icon"></span>
								</div>
							) : (null)}
						</div>
					</div>)}
				{/* 每日金币任务 */}
				<div className="coinTask">
					<div className="titleWrap">
						<CardTitle title="每日金币任务" subTitle="做任务领金币换零花钱"></CardTitle>
					</div>
					<div className="taskBoard">
						{
							dailyTaskNew.map((task, index) => this.taskDataRender(task, index))
						}
					</div>
				</div>
			</React.Fragment>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs, dailyTask, isLogin, preProcess, myIntegral } = state;
  return {
    dialogs,
    dailyTask,
    isLogin,
    preProcess,
    myIntegral,
  };
};

export default connect(mapStateToProps)(CoinTask);
